function Spinner() {
  return <div className="spinner" />
}

export default Spinner
